<template>
    <section v-if="clientEmail">
        <ssn-modal></ssn-modal>
        <div class="card">
            <div class="card-body">
                <ul id="myTab" class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ 'active': businessStore.clientDetailTab == '1' }"
                            @click="businessStore.clientDetailTab = 1"
                        >
                            <vue-feather type="home" class="mr-0" size="14" />
                            Client Details
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ 'active': businessStore.clientDetailTab == '2' }"
                            @click="businessStore.clientDetailTab = 2"
                        >
                            <vue-feather type="bar-chart" class="mr-0" size="14" />
                            {{ localizationStore.translate("credit.analysis") }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ 'active': businessStore.clientDetailTab == '3' }"
                            @click="businessStore.clientDetailTab = 3"
                        >
                            <vue-feather type="tool" class="mr-0" size="14" />
                            Client Credit Report
                        </a>
                    </li>

                    <li class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ 'active': businessStore.clientDetailTab == '4' }"
                            @click="businessStore.clientDetailTab = 4"
                        >
                            <vue-feather type="layers" class="mr-0" size="14" />
                            {{ localizationStore.translate("Dispute Letters") }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ 'active': businessStore.clientDetailTab == '9' }"
                            @click="businessStore.clientDetailTab = 9"
                        >
                            <vue-feather type="mail" class="mr-0" size="14" />
                            {{ localizationStore.translate("lob.letter") }}
                        </a>
                    </li>
                    <!-- <li class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ 'active': businessStore.clientDetailTab == '5' }"
                            @click="businessStore.clientDetailTab = 5"
                        >
                            <vue-feather type="user" class="mr-0" size="14" />
                            Dispute Tracker
                        </a>
                    </li> -->
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ 'active': businessStore.clientDetailTab == '8' }"
                            @click="businessStore.clientDetailTab = 8"
                        >
                            <vue-feather type="airplay" class="mr-0" size="14" />
                            {{ localizationStore.translate("thirty.day.report") }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ 'active': businessStore.clientDetailTab == '6' }"
                            @click="businessStore.clientDetailTab = 6"
                        >
                            <vue-feather type="info" class="mr-0" size="14" />
                            {{ localizationStore.translate("credit.contact") }}
                        </a>
                    </li>
                    <!-- <li class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ 'active': businessStore.clientDetailTab == '7' }"
                            @click="businessStore.clientDetailTab = 7"
                        >
                            <vue-feather type="file-text" class="mr-0" size="14" />
                            {{ localizationStore.translate("invoice") }}
                        </a>
                    </li> -->
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ 'active': businessStore.message == '10' }"
                            @click="businessStore.clientDetailTab = 10"
                        >
                            <vue-feather class="mr-50" type="message-circle"></vue-feather>
                            <span>{{ localizationStore.translate('messages') }}</span>
                        </a>
                    </li>

                </ul>
                <div class="tab-content">
                    <div
                        v-if="businessStore.clientDetailTab == '1'"
                        class="tab-pane"
                        :class="{ 'active': businessStore.clientDetailTab == '1' }"
                    >
                        <div class="row match-height">
                            <credit-monitoring :client-email="clientEmail" ></credit-monitoring>
                            <div class="col-lg-4 col-12 mx-auto">
                                <div
                                    class="card card-statistics"
                                    :class="{ 'border-primary border-darken-1': $route.name == 'report' }"
                                >
                                    <div class="card-header mx-auto">
                                        <h3 class="card-title text-primary">Credit Scores</h3>
                                    </div>
                                    <div class="dashboardScore">
                                        <credit-scores :client-email="clientEmail" />
                                    </div>
                                </div>
                            </div>
                            <dispute-count></dispute-count>
                        </div>
                        <div class="row ">
                            <div class="col-xl-4 col-lg-4 col-md-4">
                                <div class="card border-primary border-darken-1">
                                    <div class="card-body">
                                        <div class="d-flex align-items-baseline justify-content-around">
                                            <h5 class="card-title mb-1">
                                                Payment Status:
                                            </h5>
                                            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                                <label
                                                    class="btn btn-outline-secondary"
                                                    :class="{ active: userStore.user?.recurly_subscription_state == 'none' }"
                                                >
                                                    <input
                                                        type="radio"
                                                        name="radio_options"
                                                        id="radio_option1"
                                                        :checked="userStore.user?.recurly_subscription_state == 'none'"
                                                        :disabled="userStore.user?.recurly_subscription_state != 'none'"
                                                    />
                                                    <span>
                                                        <span v-if="userStore.user?.recurly_subscription_state == 'none'" class="avatar align-baseline">
                                                            <span class="avatar-status-offline"></span>
                                                        </span>
                                                        None
                                                    </span>
                                                </label>
                                                <label
                                                    class="btn btn-outline-primary"
                                                    :class="{ active: userStore.user?.recurly_subscription_state == 'active' }"
                                                >
                                                    <input
                                                        type="radio"
                                                        name="radio_options"
                                                        id="radio_option2"
                                                        :checked="userStore.user?.recurly_subscription_state == 'active'"
                                                        :disabled="userStore.user?.recurly_subscription_state != 'active'"
                                                    />
                                                    <span>
                                                        <span v-if="userStore.user?.recurly_subscription_state == 'active'" class="avatar align-baseline">
                                                            <span class="avatar-status-online"></span>
                                                        </span>
                                                        Active
                                                    </span>
                                                </label>
                                                <label
                                                    class="btn btn-outline-danger"
                                                    :class="{ active: userStore.user?.recurly_subscription_state == 'expired' }"
                                                >
                                                    <input
                                                        type="radio"
                                                        name="radio_options"
                                                        id="radio_option3"
                                                        :checked="userStore.user?.recurly_subscription_state == 'expired'"
                                                        :disabled="userStore.user?.recurly_subscription_state != 'expired'"
                                                    />
                                                    <span>
                                                        <span v-if="userStore.user?.recurly_subscription_state == 'expired'" class="avatar align-baseline">
                                                            <span class="avatar-status-busy"></span>
                                                        </span>
                                                        Expired
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                        <h5 class="card-title text-primary text-center mb-0">Contact Information</h5>
                                        <profile></profile>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-7 col-md-7 col-sm-12">
                                <!-- start of client report form -->
                                <div class="card border-primary border-darken-1">
                                    <div class="card-header d-flex justify-content-between pb-2">
                                        <div class="card-title">
                                            <h5 class="m-0 me-2 card-title text-center text-primary">Credit Monitoring Service</h5>
                                            <small class="text-muted text-center">1 Click Import</small>
                                        </div>
                                    </div>
                                    <div class="row custom-options-checkable gx-3 gy-2 p-1 match-height">
                                        <div class="col-md-4 ml-auto">
                                            <label class="custom-option-item text-center p-1 bg-transparent border-primary h-100" for="credit-monitoring-agency">
                                                <img
                                                    :src="reportStore.creditMonitoringAgencies[userStore.user.defaultCreditMonitoringAgency]?.icon"
                                                    :alt="reportStore.creditMonitoringAgencies[userStore.user.defaultCreditMonitoringAgency]?.name"
                                                />
                                                <a
                                                    v-if="userStore.user.affiliate_links && userStore.user.defaultCreditMonitoringAgency == reportStore.smartcredit"
                                                    :href="userStore.user.affiliate_links.smart_credit"
                                                    target="_blank"
                                                    class="btn btn-sm btn-primary"
                                                >
                                                    <span class="mr-25">Sign-Up SmartCredit</span>
                                                    <vue-feather type="external-link" size="12" />
                                                </a>
                                                <a
                                                    v-else-if="userStore.user.affiliate_links && userStore.user.defaultCreditMonitoringAgency == reportStore.myfreescorenow"
                                                    :href="userStore.user.affiliate_links.myfreescorenow"
                                                    target="_blank"
                                                    class="btn btn-sm btn-primary"
                                                >
                                                    <span class="mr-25">
                                                        {{ localizationStore.translate('myfreescorenow.signup.title') }}
                                                    </span>
                                                    <vue-feather size="12" type="external-link" />
                                                </a>
                                                <a
                                                    v-else-if="userStore.user.affiliate_links && userStore.user.defaultCreditMonitoringAgency == reportStore.identityiq"
                                                    :href="userStore.user.affiliate_links.identity_iq"
                                                    target="_blank"
                                                    class="btn btn-sm btn-primary"
                                                >
                                                    <span class="mr-25">
                                                        Sign-Up IdentityIQ
                                                    </span>
                                                    <vue-feather size="12" type="external-link" />
                                                </a>
                                                <a
                                                    v-else-if="userStore.user.affiliate_links && userStore.user.defaultCreditMonitoringAgency == reportStore.myscoreiq"
                                                    :href="userStore.user.affiliate_links.myscore_iq"
                                                    target="_blank"
                                                    class="btn btn-sm btn-primary"
                                                >
                                                    <span class="mr-25">
                                                        {{ localizationStore.translate('myscoreiq.signup') }}
                                                    </span>
                                                    <vue-feather type="external-link" size="12" />
                                                </a>
                                                <a
                                                    v-else-if="userStore.user.affiliate_links && userStore.user.defaultCreditMonitoringAgency == reportStore.creditfixrrreports"
                                                    :href="userStore.user.affiliate_links.creditfixrrreports"
                                                    target="_blank"
                                                    class="btn btn-sm btn-primary"
                                                >
                                                    <span class="mr-25">
                                                        {{ localizationStore.translate('creditfixrrreports.signup') }}
                                                    </span>
                                                    <vue-feather type="external-link" size="12" />
                                                </a>
                                                <p class="text-primary">
                                                    Selected
                                                </p>
                                            </label>
                                        </div>
                                        <div class="col-md-4 mr-auto">
                                            <label @click="openModal('#credit-monitoring-agencies-modal')" class="custom-option-item text-center p-1 bg-transparent h-100">
                                                <vue-feather type="more-horizontal" size="24" />
                                                <h3 class="custom-option-item-title fw-bolder">Choose A Different</h3>
                                                <p>Credit Monitoring Service</p>
                                            </label>
                                        </div>
                                    </div>
                                    <smart-credit-report v-if="userStore.user.defaultCreditMonitoringAgency == reportStore.smartcredit" />
                                    <my-free-score-now-form v-else-if="userStore.user.defaultCreditMonitoringAgency == reportStore.myfreescorenow" />
                                    <identity-iq v-else-if="userStore.user.defaultCreditMonitoringAgency == reportStore.identityiq" />
                                    <my-score-iq-report v-else-if="userStore.user.defaultCreditMonitoringAgency == reportStore.myscoreiq" />
                                    <creditfixrr-reports-form v-else-if="userStore.user.defaultCreditMonitoringAgency == reportStore.creditfixrrreports" />
                                </div>
                                <!-- end -->
                                <proof-identity-document></proof-identity-document>
                            </div>
                        </div>
                        
                    </div>
                    <div
                        v-else-if="businessStore.clientDetailTab == '2'"
                        class="tab-pane"
                        :class="{ 'active': businessStore.clientDetailTab == '2' }"
                    >
                        <credit-analysis :client-email='clientEmail'></credit-analysis>
                    </div>
                    <div
                        v-else-if="businessStore.clientDetailTab == '3'"
                        class="tab-pane"
                        :class="{ 'active': businessStore.clientDetailTab == '3' }"
                    >
                        <report :client-email='clientEmail'></report>
                    </div>
                    <div
                        v-else-if="businessStore.clientDetailTab == '4'"
                        class="tab-pane"
                        :class="{ 'active': businessStore.clientDetailTab == '4' }"
                    >
                        <dispute-report></dispute-report>
                    </div>
                    <!-- <div
                        v-else-if="businessStore.clientDetailTab == '5'"
                        class="tab-pane"
                        :class="{ 'active': businessStore.clientDetailTab == '5' }"
                    >
                        <dispute-letter-tracker></dispute-letter-tracker>
                    </div> -->
                    <div
                        v-else-if="businessStore.clientDetailTab == '6'"
                        class="tab-pane"
                        :class="{ 'active': businessStore.clientDetailTab == '6' }"
                    >
                        <credit-contact-tab />
                    </div>
                    <!-- <div
                        v-else-if="businessStore.clientDetailTab == '7'"
                        class="tab-pane"
                        :class="{ 'active': businessStore.clientDetailTab == '7' }"
                    >
                        <invoice-tab :invoice='invoice' />
                    </div> -->
                    <div
                        v-else-if="businessStore.clientDetailTab == '8'"
                        class="tab-pane"
                        :class="{ 'active': businessStore.clientDetailTab == '8' }"
                    >
                        <thirty-day-report :client-email='clientEmail'></thirty-day-report>
                    </div>
                    <div
                        v-else-if="businessStore.clientDetailTab == '9'"
                        class="tab-pane"
                        :class="{ 'active': businessStore.clientDetailTab == '9' }"
                    >
                        <mails-tab />
                    </div>
                    <div
                        v-else-if="businessStore.clientDetailTab == '10'"
                        class="tab-pane"
                        :class="{ 'active': businessStore.clientDetailTab == '10' }"
                    >
                        <messages-component :client="userStore.user.id"/>
                    </div>
                </div>
            </div>
        </div>
        <email v-bind:have-letter="true" />
        <credit-monitoring-agencies-modal id="credit-monitoring-agencies-modal" />
    </section>
    <loading v-else />
</template>

<script>
    import { useLocalizationStore } from '../stores/LocalizationStore.js'
    import { useBusinessStore } from '../stores/BusinessStore.js'
    import { useReportStore } from '../stores/ReportStore.js'
    import { useUserStore } from '../stores/UserStore.js'
    import TabComponent from './mail/TabComponent.vue'
    import { ref, reactive, computed } from 'vue'
    import Loader from './report/Loader'
    import { openModal } from '../utilities/_helpers'
    import CreditMonitoringAgenciesModal from './modals/CreditMonitoringAgencies.vue';
    import CreditfixrrReportsForm from './report/form/CreditfixrrReportsComponent.vue'
    import ContractDownloadComponent from './user/ContractDownloadComponent.vue';

    export default {
        components:{
            'mails-tab': TabComponent,
            'loading': Loader,
            CreditMonitoringAgenciesModal,
            CreditfixrrReportsForm,
        },
        mounted() {
            useUserStore().fetchUser();
        },
        watch: {
            'userStore.user'(value) {
                if (value != null) {
                    this.clientEmail = value.email;
                }
                if(value.isTeamMember){
                    this.userStore.fetchCheckValidUserDispute()
                }
            },
        },
        props: {
            invoice: {
                type: [Array, Object]
            }
        },
        setup() {
            return {
                localizationStore: useLocalizationStore(),
                businessStore: useBusinessStore(),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                clientEmail: ref(null),
                openModal: openModal,
            }
        },
    }
</script>
